import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { MainService } from './main.service';
import { session } from '../../../environments/environment.session'
import { MakingDataService } from 'src/app/md/service/making-data.service';

@Injectable({
  providedIn: 'root'
})
export class BpService {

  httpUrl;
  constructor(private http: HttpClient, private main: MainService, private mds: MakingDataService) {
    this.httpUrl = this.main.httpUrl + "/accounts/bp";
  }


  async getPopUpData(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/getdataforbp' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getList(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/getAllBp' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async create(obj: any) {
    console.log(obj);

    const res = await this.http.post<any>(this.httpUrl + '/createBp', this.mds.dataE(obj)).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async delete(obj: any) {
    const res = await this.http.delete<any>(this.httpUrl + '/deleteBp'+JSON.stringify({}), { headers: new HttpHeaders().append('data', await this.mds.dataE(obj)) }).toPromise().then( async res => {
      // return await this.mds.dataD(res);
      return  res
    });
    return res;
  }

  // async projectMappedBank(obj:any){
  //   const res = await this.http.post<any>(this.httpUrl + '/projectMappedBank',obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return res;
  // }
  async projectMappedBank(obj: any) {
    const res = await this.http.post<any>(this.httpUrl + '/bankOnProject', obj).toPromise().then(res => {
      return res;
    });
    return res;
  }



  async getbpData(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/getbpData' + {}, { headers: new HttpHeaders().append('data', await this.mds.dataE(obj)) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getbpDataByVendor(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/getVendorBPData' + {}, { headers: new HttpHeaders().append('data', await this.mds.dataE(obj)) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async deleteAdvice(obj: any) {
    const res = await this.http.delete<any>(this.httpUrl + '/deleteAdvice' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async insertProcessedbp(obj: any) {
    const res = await this.http.post<any>(this.httpUrl + '/insertProcessedbp', obj).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async createAdvice(obj: any) {
    const res = await this.http.post<any>(this.httpUrl + '/createAdvice', obj).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async getAdvice(obj: any) {
    const res = await this.http.get<any>(this.httpUrl + '/getAdvice' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }




  async updateStatus(obj: any) {
    const res = await this.http.put<any>(this.main.httpUrl + '/accounts/bp/updateStatus', this.mds.dataE(obj)).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async updateBpStatusInJrnl(obj: any) {
    const res = await this.http.put<any>(this.main.httpUrl + '/accounts/bp/updateBpStatusInJrnl', obj).toPromise().then(res => {
      return res;
    });
    return res;
  }

  async changes_status(obj: any) {
    const res = await this.http.post<any>(this.httpUrl + '/changestatus', obj).toPromise().then(res => {
      return res;
    });
    return res;
  }

  async exportExcelOfSalary(obj: any) {
   return await this.http.post(this.httpUrl + '/exportExcelOfSalary', this.mds.dataE(obj), { responseType: 'blob' }).toPromise().catch((err)=>{
return true
  })
  
  }


}
